import { Message } from '@ok/okd';

const { ont } = window.utils;

// Shared response handling: unwrap `code==0` to data, toast errors, null out 401.
function handleResponse(request, showErrorMsg) {
  return request
    .then(({ data }) => {
      if (data.code == 0) {
        return data.data;
      }

      // Unified processing of error messages
      if (showErrorMsg && data?.msg) {
        Message.error(data.msg);
      }

      throw data;
    })
    .catch((err) => {
      let handleErr = err;
      if (err.status === 401) {
        handleErr = null;
      }
      throw handleErr;
    });
}

export async function get(url, params = {}, showErrorMsg = true, config) {
  // GET carries no body: `params` lives inside its config (2nd arg).
  return handleResponse(ont.get(url, { params, ...config }), showErrorMsg);
}

export async function post(url, params = {}, showErrorMsg = true, config) {
  // POST sends `params` as the body (2nd arg) and config as the 3rd.
  return handleResponse(
    ont.post(url, params || undefined, config),
    showErrorMsg
  );
}

export default ont;
